import { render, staticRenderFns } from "./GalleryEvents.vue?vue&type=template&id=41bef035&scoped=true&"
import script from "./GalleryEvents.vue?vue&type=script&lang=js&"
export * from "./GalleryEvents.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEvents.vue?vue&type=style&index=0&id=41bef035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bef035",
  null
  
)

export default component.exports